module.exports = __webpack_public_path__ + "img/logo3-light.e148ef3c.svg";